import { render, staticRenderFns } from "./tab_trans_cards_check.vue?vue&type=template&id=722c5e52&scoped=true"
import script from "./tab_trans_cards_check.vue?vue&type=script&lang=js"
export * from "./tab_trans_cards_check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722c5e52",
  null
  
)

export default component.exports